import { MatchArchiveFilterTypes, DashboardViewStates } from './constants';
import { MatchArchiveFilterType } from './types';
import { CandidateMatchInterface } from 'features/Connect/features/ConnectCandidatePortalDashboards/CandidateMatchDashboard/utils/types';

export const getFilteredArchivedMatches = (
  candidateMatches: {
    accepted?: CandidateMatchInterface[];
    rejected?: CandidateMatchInterface[];
    previously_actioned?: CandidateMatchInterface[];
  } | null,
  activeFilter: MatchArchiveFilterType
): CandidateMatchInterface[] => {
  let matches: CandidateMatchInterface[] = [];

  switch (activeFilter) {
    case MatchArchiveFilterTypes.INTERESTED:
      matches = candidateMatches?.accepted || [];
      break;
    case MatchArchiveFilterTypes.NO_THANKS:
      matches = candidateMatches?.rejected || [];
      break;
    case MatchArchiveFilterTypes.ALL:
    default:
      matches = [
        ...(candidateMatches?.accepted || []),
        ...(candidateMatches?.rejected || []),
        ...(candidateMatches?.previously_actioned || []),
      ];
      break;
  }

  return matches.sort((a, b) => {
    const dateA = new Date(a.modified || a.created || 0);
    const dateB = new Date(b.modified || b.created || 0);

    return dateB.getTime() - dateA.getTime();
  });
};

export const getTotalArchivedMatches = (
  candidateMatches: {
    accepted?: CandidateMatchInterface[];
    rejected?: CandidateMatchInterface[];
    previously_actioned?: CandidateMatchInterface[];
  } | null
): number => {
  return (
    (candidateMatches?.accepted?.length || 0) +
    (candidateMatches?.rejected?.length || 0) +
    (candidateMatches?.previously_actioned?.length || 0)
  );
};

export const hasAcceptedMatches = (
  candidateMatches: {
    accepted?: CandidateMatchInterface[];
  } | null
): boolean => {
  return (candidateMatches?.accepted?.length || 0) > 0;
};

export const hasRejectedMatches = (
  candidateMatches: {
    rejected?: CandidateMatchInterface[];
  } | null
): boolean => {
  return (candidateMatches?.rejected?.length || 0) > 0;
};

export const shouldShowDashboard = (totalArchivedMatches: number): boolean => {
  return totalArchivedMatches > 0;
};

export type DashboardViewState = DashboardViewStates;

export const getDashboardViewState = (
  isUserOpenToWorkAndMatches: boolean,
  isFetchingMatches: boolean,
  hasInitiallyFetchedMatches: boolean,
  shouldShowDashboardValue: boolean,
  filteredArchivedMatchesLength: number
): DashboardViewState => {
  if (!isUserOpenToWorkAndMatches) {
    return DashboardViewStates.NOT_OPEN_TO_MATCHES;
  }

  if (isFetchingMatches || (!hasInitiallyFetchedMatches && isFetchingMatches)) {
    return DashboardViewStates.LOADING;
  }

  if (!shouldShowDashboardValue) {
    return DashboardViewStates.NO_ARCHIVED_MATCHES;
  }

  if (filteredArchivedMatchesLength === 0) {
    return DashboardViewStates.NO_ARCHIVED_MATCHES;
  }

  return DashboardViewStates.HAS_ARCHIVED_MATCHES;
};
